import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    for (let i = 0; i < this.buttonTargets.length; i++) {
      this.buttonTargets[i].classList.add('hidden');
    }
  }

  trigger(ev) {
    ev.target.form.dispatchEvent(new CustomEvent('submit', {bubbles: true}));
  }
}
